import React from 'react';
import styled from 'styled-components';

const formatText = number => {
  const text = number === 1 ? 'avaliação' : 'avaliações';
  const count = number ? number : 'sem';

  return number === undefined ? null : `(${count} ${text})`;
};

const Radio = ({ label, selected, onChange, name, countReview }) => {
  const checked = label === selected;

  return (
    <OptionWrapper checked={checked} className={checked ? 'checked' : ''}>
      <OptionLabel>
        {label} <CountReview>{formatText(countReview)}</CountReview>
        <input type="radio" value={label} name={name} checked={checked} onChange={onChange} readOnly hidden />
      </OptionLabel>
    </OptionWrapper>
  );
};

export default Radio;

const CountReview = styled.span`
  color: #999999;
  font-size: 11px;
  padding: 0 5px;
  font-weight: normal;
`;

const OptionWrapper = styled.span`
  border-bottom: 1px solid #e1e1e1;
  display: block;
  position: relative;

  &:last-child {
    border-bottom: none;
  }

  &.checked {
    &::before {
      content: '';
      position: absolute;
      top: calc(50% - 10px);
      right: 0px;
      margin-right: 8px;
      width: 5px;
      height: 10px;
      display: ${({ checked }) => checked};
      border: solid #000;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }

    > label {
      color: #000;
      font-weight: 600;
    }
  }
`;

const OptionLabel = styled.label`
  padding: 15px 0;
  font-size: 14px;
  display: block;
  cursor: pointer;
  color: #666;
`;
